module.exports = __webpack_public_path__ + "img/globe-life.88020717.png";